import { CultureInfo } from '../culture-info.model';
import { CultureInfoFfLatn } from './ff-Latn';

/**
 * @ignore
 */
export const CultureInfoFfLatnSN: CultureInfo = {
  name: 'ff-Latn-SN',
  displayName: 'Fulah (Latin, Senegal)',
  iso3LanguageCode: 'ful',
  iso2LanguageCode: 'ff',
  ietfLanguageTag: 'ff-Latn-SN',
  parent: CultureInfoFfLatn
};
